// Types
export interface InvitationData {
  action: string;
  isAgendaShared: boolean;
  isInvitationAccepted: boolean;
  pe_id: string;
  expert_id: string;
  project_id: string;
  user_id: string;
}

export interface ApiResponse {
  success: boolean;
  data?: InvitationData;
  message?: string;
}

export interface ErrorState {
  type: string;
  title: string;
  message: string;
  showDashboardLink?: boolean;
}

export interface UseInvitationValidationReturn {
  data: InvitationData | null;
  isLoading: boolean;
  error: ErrorState | null;
  refetch: () => void;
}

// Constants for API response messages
export const API_MESSAGES = {
  INCORRECT_USER: 'INCORRECT_USER',
  INVITATION_ACCEPTED_AGENDA_NOT_SHARED: 'INVITATION_ACCEPTED_AGENDA_NOT_SHARED',
  NO_LINK_RECORD: 'NO_LINK_RECORD',
  PROCESSED_LINK: 'PROCESSED_LINK',
  LINK_EXPIRED: 'LINK_EXPIRED',

} as const;

export const ACTIONS = {
  SHOW_STEPS: 'ShowSteps',
} as const;